import React, {FC, useEffect, useState} from 'react'
import axios from 'axios'
import {
  Button,
  Card,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from 'react-bootstrap'
import AddNewPriceTemplateModal from '../AddNewPriceTemplateModal'
import AddNewTitleDescriptionModal from '../AddNewTitleDescriptionModal'
import AddNewRecipeModal from '../AddNewRecipeModal'
import {useAppDispatch} from 'src/redux/storeHooks'
import {PlatformDataType} from 'src/interfaces/Platform.interface'
import {
  deleteCategoryTemplateDataAsync,
  deleteRecipeAsync,
  deleteTitleDescriptionTemplateAsync,
  getMoreMappingAsync,
  getPlatformCategoryTemplateDataAsync,
  getPlatformTitleDescriptionTemplateAsync,
  getRecipesAsyncUsingPlatformId,
} from 'src/redux/actions/templateAndPricingActions'

import useAppToast from 'src/hooks/useAppToast'
import {
  deletPlatformPriceAsync,
  getPlatformPriceAsync,
} from 'src/redux/actions/productPricingAction'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowDown, faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import AddNewCategoryTemplateModal from '../AddNewCategoryTemplateModal'
import {toast} from 'react-toastify'
import {
  CATEGORY_ITEM,
  MoreFieldMappingItem,
  MoreMapping_Item_On_Get,
  PRICE_TEMPLATE_ITEM,
  PRICE_TEMPLATE_FIELD,
  RECIPE,
  TITLE_DESCRIPTION_TEMPLATE_ITEM,
} from 'src/interfaces/Template.interface'
import TemplateListItemcopy from '../TemplateListItemcopy'
import {getPlatformFieldsAsync} from 'src/redux/actions/productActions'
import AddNewMoreMappingTemplateModal from '../AddNewMoreMappingTemplateModal'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import MoreMappingItem from '../MoreMappingItem'
import { accessSessionTokenKeyName, loggedInAdminAccessToken } from 'src/utils/constants'
import { formatTimeZone } from 'src/utils/TimeZoneDateFormat'
import AttributeAndOptionValueMappingModal from '../AttributeAndOptionValueMappingModal'
import { deleteOptionsAttributeMapping, getOptionAttributeMappingList } from 'src/redux/actions/AttributeAndOptionValueMappingActions'
import { useDebounce, getApiErrorMessage, handleThunkResponse, isApiPayloadSuccess} from 'src/marketConnect/helpers'
import CreateQuickListTab from './CreateQuickListTab.legacy'
import { usePermission } from 'src/hooks/usePermission'




type TemplateComponentProps = {
    item:PlatformDataType
    platformPricingTemplateLoading:boolean,
    setShowRefreshModal:React.Dispatch<React.SetStateAction<boolean>>
    setRefreshPlatformId:React.Dispatch<React.SetStateAction<number | null>>
    currentActivePlatform:number | undefined
}

const TemaplateComponent:FC<TemplateComponentProps> = ({
    item,
    platformPricingTemplateLoading,
    setShowRefreshModal,
    setRefreshPlatformId,
    currentActivePlatform
  }) => {
  const {isRead, isWrite, isDelete} = usePermission();
    const [showAddTitleDescriptionModal, setShowAddTitleDescriptionModal] = useState<boolean>(false)
    const [selectedPlatformId, setSelectedPlatformId] = useState<any>(item)
    const [showTable, setShowTable] = useState(false)
    const [isAccordionOpen, setIsAccordionOpen] = useState(true);
    const [categoryTemplateForUpdate, setCategoryTemplateForUpdate] = useState<CATEGORY_ITEM | null>(
      null
    ) // State to store selected template data
  
    const [activeTab, setActiveTab] = useState({tab1: false, tab2: false, tab3: false,tab4:true})
    const [priceingTabel, setPriceingTabel] = useState<boolean>(false)
    const [showPriceTemplateModal, setShowPriceTemplateModal] = useState<boolean>(false)
    const [updatePriceItem, setUpdatePriceItem] = useState<PRICE_TEMPLATE_ITEM | null>(null)
    const [initialPriceTypesForModal, setInitialPriceTypesForModal] = useState<PRICE_TEMPLATE_FIELD[]>([])
    const [showAddRecipeModal, setShowAddRecipeModal] = useState<boolean>(false)
    const [priceTemplateList, setPriceTemplateList] = useState<PRICE_TEMPLATE_ITEM[] | []>([])
    const [priceTemplatePagination, setPriceTemplatePagination] = useState({
      page: 1,
      limit: 10,
      count: 0,
      previous: null,
      next: null,
    })
 
    const [paginationCategoryData, setPaginationCategoryData] = useState({
      page: 1,
      limit: 10,
      count: 0,
      previous: null,
      next: null,
    })
    const [showCategoryData1, setShowCategoryData1] = useState(false)
    const [showMoreMappingTemplateTable, setshowMoreMappingTemplateTable] = useState(false)
    const [showRecipeData, setShowRecipeData] = useState(false)
    const [showOptionsAndAttributeModal, setShowOptionsAndAttributeModal] = useState(false)
    const [loadRecipeData, setLoadRecipeData] = useState<boolean>(false)
    const [platformCategories, setPlaformCategories] = useState<CATEGORY_ITEM[] | []>([])
    const [loadCategorieData, setloadCategorieData] = useState<boolean>(false)
    const [platformRecipes, setPlatformRecipes] = useState<any[]>([])
    const [ recipePagination, setRecipePagination] = useState({
      page: 1,
      limit: 10,
      count: 0,
      previous: null,
      next: null,
    })
    const [updatingRecipeData, setUpdatingRecipeData] = useState<RECIPE | null>(null)
    const [showCategoryTemplateModal, setShowCategoryTemplateModal] = useState<boolean>(false)
    const [loadTitleDescription, setLoadTitleDescription] = useState(false)
    const [titleDescriptionList, setTitleDescriptionList] = useState<
      TITLE_DESCRIPTION_TEMPLATE_ITEM[] | []
    >([])
    const [updatingTitleDescriptionData, setUpdatingTitleDescriptionData] =
      useState<TITLE_DESCRIPTION_TEMPLATE_ITEM | null>(null)
    const [titleDescriptionPagination, setTitleDescriptionPagination] = useState({
      page: 1,
      limit: 10,
      count: 0,
      previous: null,
      next: null,
    })
    const [optionAttributeList, setOptionAttributeList] = useState<any>([])
    const [optionAttributeListAll, setOptionAttributeListAll] = useState<any>([])
  
    const [moreFieldMappingData, setMoreFieldMappingData] = useState<MoreFieldMappingItem[]>([])
    const [showMoreMapping, setShowMoreMapping] = useState<boolean>(false)
    const [showMoreMappingTemplateModal, setShowMoreMappingTemplateModal] = useState<boolean>(false)
    const [selectedMappingItem, setSelectedMappingItem] = useState<MoreFieldMappingItem | null>(null)
          useEffect(() => {
      if (selectedMappingItem?.id) {
        getMoreMappingDataAsync()
      }
    }, [selectedMappingItem]) // Dependency array includes selectedMappingItem
  
    const [moreMappingsPagination, setMoreMappingsPagination] = useState({
      page: 1,
      limit: 5,
      count: 0,
      previous: null,
      next: null,
    })
    const [getMoreMappingData, setGetMoreMappingData] = useState<MoreMapping_Item_On_Get[] | []>([])
    const [getShowMoreMappingData, setGetShowMoreMappingData] = useState(false)
  
    const [updatingMoreMappingData, setUpdatingMoreMappingData] = useState<MoreMapping_Item_On_Get | null>(
      null
    )
    const [mappingLoading, setMappingLoading] = useState<boolean>(false)
    const [showAlertModalTitle, setShowAlertModalTitle] = useState<boolean>(false)
    const [showAlertModalPrice, setShowAlertModalPrice] = useState<boolean>(false)
    const [showAlertModalCategory, setShowAlertModalCategory] = useState<boolean>(false)
    const [showAlertModalListing, setShowAlertModalListing] = useState<boolean>(false)
    const [selectedTemplateDataForDelete, setSelectedTemplateDataForDelete] = useState<null|any>()
    const [optionAttributeListLoading, setOptionAttributeListLoading] = useState(false);
    const [showOptionDataAttributeMappingDelete, setShowOptionDataAttributeMappingDelete] = useState<boolean>(false)
    const [selectedMappedAttributeForDelete, setSelectedMappedDataAttributeForDelete] = useState<null|any>()
    const [selectedMappedAttributeForEdit, setSelectedMappedDataAttributeForEdit] = useState<null|any>()
    const [optionAttributePagination, setOptionAttributePagination] = useState({
      page: 1,
      limit: 5,
      count: 0,
      skip: 0,
    })


    const dispatch = useAppDispatch()

    const {successToast, warningToast, errorToast} = useAppToast()
    const [search, setSearch] = useState({
    title: "",
    category: "",
    price: "",
    plan:""
  })
   
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setSearch((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

    const onClickAddNewRecipeModal = () => {
      setUpdatingRecipeData(null)
      setShowAddRecipeModal(true)
    }
  
  
    const handleUpdateCategory = (templateData) => {
      setCategoryTemplateForUpdate(templateData)
      setShowCategoryTemplateModal(true)
    }
  
    
  
    const handleUpdatePrice = (templateData) => {
      setUpdatePriceItem(templateData)
      setShowPriceTemplateModal(true)
    }
  
    const handleCloseModal = () => {
      setShowAddTitleDescriptionModal(false)
      setUpdatingTitleDescriptionData(null)
    }
    
    const getOptionAttributeMaping = (page = 1, forceFetch = false) => {
      setOptionAttributeListLoading(true)
      const limit = optionAttributePagination.limit
      const skip = (page - 1) * limit
      if (forceFetch) {
        setOptionAttributeListAll([])
      }
      if (optionAttributeListAll.length > 0 && !forceFetch) {
        setOptionAttributeList(optionAttributeListAll.slice(skip, skip + limit))
        setOptionAttributePagination((prev) => ({
          ...prev,
          page,
          count: optionAttributeListAll.length,
          skip,
        }))
        setOptionAttributeListLoading(false)
        return
      }
      dispatch(
        getOptionAttributeMappingList({platformId: item.id!, skip, limit})
      ).then((response) => {
        const payload = response?.payload;
        const data = payload?.data || payload?.results || [];
        const totalCount =
          Number(payload?.count ?? payload?.data?.count ?? payload?.total ?? 0);
        const list = Array.isArray(data) ? data : [];
        if (list.length > limit || totalCount === list.length) {
          setOptionAttributeListAll(list)
          setOptionAttributeList(list.slice(skip, skip + limit))
        } else {
          setOptionAttributeList(list)
        }
        setOptionAttributePagination((prev) => ({
          ...prev,
          page,
          count: totalCount || list.length,
          skip,
        }))
      }).catch((err)=>{
        console.log("error",err);
      }).finally(()=> setOptionAttributeListLoading(false))
    }
  
    const getTitleDescriptionListAsync = (page = 1) => {
      setShowTable(true)
      setLoadTitleDescription(true)
      dispatch(
        getPlatformTitleDescriptionTemplateAsync({
          platform_id: item.id+'',
          paginationdata: {page: page, limit: 10,search: search.title},
        })
      ).then((response) => {
        setTitleDescriptionList(response.payload.results)
        setTitleDescriptionPagination((pre) => ({
          ...pre,
          count: response.payload.count,
          previous: response.payload.previous,
          next: response.payload.next,
        }))
        setLoadTitleDescription(false)
      })
    }

 const debouncedSearchTitle = useDebounce(search.title, 500)

    useEffect(() => {
     getTitleDescriptionListAsync(1);
      setShowTable(true);
    }, [debouncedSearchTitle]);



    const getRecipesAsync = (page = 1) => {
      setShowRecipeData(true)
      setLoadRecipeData(true)
      dispatch(
        getRecipesAsyncUsingPlatformId({platformId: item.id!+'', otherParams: {page: page, limit: 5,search:search.plan}})
      ).then((response) => {
        setPlatformRecipes(response.payload.results)
        setRecipePagination((pre) => ({
          ...pre,
          page: page,
          count: response.payload.count,
          previous: response.payload.previous,
          next: response.payload.next,
        }))
        setLoadRecipeData(false)
      })
    }


 const debouncedSearchPlan = useDebounce(search.plan, 500)

    useEffect(() => {
   getRecipesAsync()
    }, [debouncedSearchPlan]);

  
    const getPriceTemplateAsync = (page = 1) => {
      setPriceingTabel(true)
      dispatch(
        getPlatformPriceAsync({platform_id: item.id!+'', paginationdata: {page: page, limit: 10,search:search.price}})
      ).then((response) => {
        setPriceTemplateList(response.payload.results)
        setPriceTemplatePagination((pre) => ({
          ...pre,
          page: page,
          count: response.payload.count,
          previous: response.payload.previous,
          next: response.payload.next,
        }))
        // setLoadRecipeData(false)
      })
    }
 const debouncedSearchPrice = useDebounce(search.price, 500)

    useEffect(() => {
      getPriceTemplateAsync()
    }, [debouncedSearchPrice]);


    const callFieldMapping = (item) => {
      setMappingLoading(true)
  
      if (item) {
        dispatch(
          getPlatformFieldsAsync({
            platformId: item,
            otherParams: {field_code: '', allowMapViaTemplate: true},
          })
        ).then((response) => {
          if (response?.payload?.length) {
            setMappingLoading(false)
            setShowMoreMapping(response?.payload?.length>0 ? true : false)
            setMoreFieldMappingData(response?.payload)
          } else {
            setMappingLoading(false)
            // warningToast('No additional rule found')
          }
  
        })
      }
    }
    
  
    const getCategoriesAsync = (page = 1) => {
      setShowCategoryData1(true)
      setloadCategorieData(true)
      dispatch(
        getPlatformCategoryTemplateDataAsync({
          platform_id: item.id!,
          paginationdata: {page: page, limit: 10,search:search.category},
        })
      ).then((response) => {
        setPlaformCategories(response.payload.results)
        setPaginationCategoryData((pre) => ({
          ...pre,
          page: page,
          count: response.payload.count,
          previous: response.payload.previous,
          next: response.payload.next,
        }))
        setloadCategorieData(false)
      })
    }

    const debouncedSearchCategory = useDebounce(search.category, 500)
    
    useEffect(() => {
      getCategoriesAsync()
    }, [debouncedSearchCategory]);

    const getMoreMappingDataAsync = (page = 1) => {
      setshowMoreMappingTemplateTable(true)
      setGetShowMoreMappingData(true)
      const fieldId = selectedMappingItem?.id
      if (fieldId) {
        //  alert(1)
        dispatch(
          getMoreMappingAsync({
            platform_id: item.id!,
            field_id: fieldId,
            paginationdata: {page: page, limit: 5,search:search[item.display_name]},
          })
        ).then((response) => {
          setGetMoreMappingData(response.payload.results)
          setGetMoreMappingData(response.payload.results)
          setMoreMappingsPagination((pre) => ({
            ...pre,
            page: page,
            count: response.payload.count,
            previous: response.payload.previous,
            next: response.payload.next,
          }))
          setGetShowMoreMappingData(false)
        })
      }
    }

    const calculateVisibleRecordRange = ({ page, limit, count }) => {
      // console.log({page, limit, count})
      const startRecord = (page - 1) * limit + 1;
      const endRecord = Math.min(page * limit, count);
      return { startRecord, endRecord };
    };

    // Record range for each paginated section
    const titleRecordRange = calculateVisibleRecordRange(titleDescriptionPagination);
    const priceRecordRange = calculateVisibleRecordRange(priceTemplatePagination);
    const categoryRecordRange = calculateVisibleRecordRange(paginationCategoryData);


    useEffect(() => {
      if(activeTab.tab1){
      getTitleDescriptionListAsync(1);
      setShowTable(true);
      }
      if (activeTab.tab3) {
        getRecipesAsync();
      }
    }, [activeTab]);

    useEffect(()=>{
      getOptionAttributeMaping(1, true);
    },[]) 

    const [showQuickTable,setShowQuickTable] = useState(true)

    const CreateQuickPlan = () => {
      setShowQuickTable(prev => !prev)
    }

    useEffect(() => {
    if (item?.id === currentActivePlatform) {
      callFieldMapping(currentActivePlatform);
    }
  }, [currentActivePlatform]);


    return (
      <div key={item?.id} className='border border-2 rounded p-4 mb-5 '>
        {activeTab.tab2 ? (
          <div className='d-flex justify-content-between align-items-start mb-3'>
            <div>
              <p className='text-gray-1000 fs-4 fw-bolder m-0'>
                Manage Attributes / Option Value Mapping ΓÇö {item?.display_name}
              </p>
              <p className='h6 text-secondary mt-2 mb-0'>
                Customize how individual attribute values from your source system map to specific values in the destination marketplace to ensure accurate product listings. For example: Map &quot;Turkish Blue&quot; from your system to &quot;Blue&quot; on the marketplace, or &quot;3XL&quot; to &quot;XXXL.&quot;
              </p>
            </div>
            <div className='d-flex align-items-center gap-2 flex-shrink-0 ms-3'>
              {isWrite && (
                <button
                  className='btn btn-sm btn-primary fw-bold'
                  onClick={() => {
                    setShowOptionsAndAttributeModal(!showOptionsAndAttributeModal)
                    setSelectedMappedDataAttributeForEdit(null)
                  }}
                >
                  + Add New Mapping
                </button>
              )}
              <button
                className='btn btn-sm btn-outline btn-outline-primary fw-bold'
                onClick={() => setActiveTab({tab1: false, tab2: false, tab3: false, tab4: true})}
                style={{padding:'.5rem'}}
              >
                <i className='bi bi-arrow-left'></i>
                Back
              </button>
            </div>
          </div>
        ) : (
        <div className='card-height'>
          <Card.Body>
            <div className='col-12  border-right-4 d-flex align-items-center'>
            {isWrite && (<div className='p-2 w-100 d-flex justify-content-between'>
              <div className='d-flex align-items-center'>
                {/* <img src={item?.platform_info?.logo_ref} className='h-40px w-40px me-3' alt='Logo' /> */}
                <p
                  className='text-gray-1000 text-hover-primary fs-4 fw-bolder m-0'
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {item?.display_name}
                </p>
              </div>
              <div className='d-flex align-items-center gap-2'>
              <button
                className='btn btn-sm btn-outline btn-outline-primary fw-bold'
                style={{padding: '.5rem'}}
                onClick={() => setActiveTab({tab1: false, tab2: true, tab3: false, tab4: false})}
              >
                <i className='bi bi-sliders me-2'></i>
                Option Value Mapping
              </button>
              {localStorage.getItem(loggedInAdminAccessToken) && <OverlayTrigger
                placement={'top'}
                overlay={<Tooltip>Click here if you are not seeing your newly Custom field or any missing information for mapping</Tooltip>}
               >
                <button className="btn btn-sm btn-primary fw-bold" onClick={()=>{
                  setShowRefreshModal(true)
                  setRefreshPlatformId(item?.id!)
                  
                }} >Refresh Fields</button>
              </OverlayTrigger>}
              </div>
            </div> )}
          </div>
          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap my-1'>
               <li className='nav-item'>
                <button
                  className={
                    activeTab.tab4
                      ? `nav-link active-tab text-active-primary text-secondary`
                      : `nav-link border-bottom text-secondary`
                  }
                  onClick={() => {
                    setActiveTab({tab1: false, tab2: false, tab3: false,tab4:true})
                  }}
                >
                  Quick List
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={
                    activeTab.tab1
                      ? `nav-link active-tab text-active-primary text-secondary`
                      : `nav-link border-bottom text-secondary`
                  } 
                  onClick={() => {
                   
                    setActiveTab({tab1: true, tab2: false, tab3: false,tab4:false})
                    // callFieldMapping(item)
                  }}
                >
                  Listing Rules
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={
                    activeTab.tab3
                      ? `nav-link active-tab text-active-primary text-secondary`
                      : `nav-link border-bottom text-secondary`
                  }
                  onClick={() => {
                    setActiveTab({tab1: false, tab2: false, tab3: true, tab4:false})
                  }}
                >
                  Listing Plan
                </button>
              </li>
            </ul>
          </div>
        </Card.Body>
        </div>
        )}
        {activeTab.tab1 && (
          <div className='p-0 p-sm-2'>
            <div className=' mt-2'>
              <div className='my-2'>
                <p className='h6 text-secondary  mb-4 '>
                Our portal's Listing Rules feature simplifies your product listings. You can easily map or customize titles and descriptions from your Source platform to destination platform, set rules to adjust/increase sales prices, choose appropriate listing categories from Destination platform, and map required product attributes. This streamlines your product management across multiple channels, saving you time and improving efficiency. You can set a Rule as Default to automatically apply to all listings.  <a href={'https://commercium.tawk.help/article/listing-rules-simplify-your-product-management'} target='_blank' rel="noreferrer" >Read More</a>
                </p>
              </div>
            
              <div className='accordion p-0 pt-2 p-sm-2' id='titleDescriptionAccordion'>
                <div className='accordion-item shadow'>
                  <h2 className='accordion-header' id='titleDescriptionHeading'>
                    <button
                      className='accordion-button'
                      type='button'
                      onClick={() => {
                        const newState = !isAccordionOpen;
                        setIsAccordionOpen(newState);
                        setShowTable(newState);

                        if (newState) {
                          getTitleDescriptionListAsync(1);
                        }
                      }}
                    >
                      <span className='required-sm'>Title Description Mapping Rule</span>
                    </button>
                  </h2>
                  <div
                    id={'titleDescriptionCollapse' + item?.id}
                    className={`accordion-collapse collapse ${isAccordionOpen ? 'show' : ''}`}
                    aria-labelledby='titleDescriptionHeading'
                    data-bs-parent='#titleDescriptionAccordion'
                  >
                    <div className='accordion-body'>
                      <div className=''>
                        <div className="row pe-sm-0">
                            <div className='col-12 col-sm-6 '>
                            <p className='fw-bold  '>
                                Add Title Description Mapping Rule for {item?.display_name}
                            </p>
                            <div className="col-6">
                                        <input
                                          className='form-control mr-sm-2 input-sm '
                                          name="title"
                                          type='search'
                                          placeholder='Search By Name'
                                          aria-label='Search'
                                          onChange={handleChange}
                                          onKeyDown={(ev) => {
                                            if (ev.key == 'Enter') {
                                             getTitleDescriptionListAsync(1);
                                             setShowTable(true);
                                          
                                            }
                                          }}
                                          value={search.title}
                                        />
                                        </div>
                            </div>
                            {isWrite && (<div className='col-12 col-sm-6  d-flex justify-content-end pe-0 mb-3'>
                            <button
                                className='btn btn-primary btn-sm align-self-end w-25'
                                onClick={() => {
                                setUpdatingTitleDescriptionData(null)
                                setShowAddTitleDescriptionModal(true)
                                }}
                            >
                                + Add New Rules
                            </button>
                            </div> )}
                        </div>
  
                        {showTable ? (
                          <div className='p-0 p-sm-2' >
                            {loadTitleDescription ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <h1>
                                  <Spinner animation='border' variant='primary' />
                                </h1>
                              </div>
                            ) : (
                              <>
                                {titleDescriptionPagination.count === 0 ? (
                                  // Content to render when recipePagination.count is equal to 0
                                  <p className='mt-3'>No Title Description Mapping Rule found </p>
                                ) : (
                                  // Content to render when recipePagination.count is not equal to 0
                                  <div>
                                      <div className='card-body w-100 py-3' style={{minHeight:"150px !important"}}>
                                        {/* begin::Table container */}
                                        <div className='table-responsive '>
                                          {/* begin::Table */}
                                          <table className='table table-striped table-hover table-sm gs-0 gy-4' >
                                            {/* begin::Table head */}
                                            <thead>
                                              <tr className='fw-bold text-muted  border-bottom border-bottom-2'>
                                                <th className='min-w-150px ps-4 '>Rule Name</th>
                                                {titleDescriptionList && <th className='min-w-150px ps-4 '>
                                                  <div className='d-flex gap-3'>Created At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div> </th>}
                                                {titleDescriptionList && <th className='min-w-150px ps-4 '>
                                                  <div className='d-flex gap-3'>Updated At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div></th>}
                                                <th className='min-w-100px ps-4 '>Actions</th>
                                              </tr>
                                            </thead>
                                            {/* end::Table head */}
                                            {/* begin::Table body */}
                                            <tbody>
                                              {titleDescriptionList?.length
                                                ? titleDescriptionList.map((templateData) => (
                                                      <TemplateListItemcopy
                                                        key={templateData.id}
                                                        name={templateData.name}
                                                        created_at={templateData?.created_at}
                                                        updated_at={templateData.updated_at}
                                                        // Pass update and delete handler functions here
                                                        onUpdate={() => {
                                                          setUpdatingTitleDescriptionData(
                                                            templateData
                                                          )
                                                          setShowAddTitleDescriptionModal(true)
                                                        }}
                                                        onDelete={() => {
                                                         
                                                          setSelectedTemplateDataForDelete(templateData)
                                                          setShowAlertModalTitle(true)
                                                          // setLoadTitleDescription(true)
                                                   
                                                        }}
                                                      />
                                                  ))
                                                : null}
                                            </tbody>
                                            {/* end::Table body */}
                                          </table>
                                          {/* end::Table */}
                                        </div>
                                        {/* end::Table container */}
                                      </div>
  
                                      <div className='d-flex flex-column'>
                                        <div className='border-bottom my-2 border-2'></div>
                                        <div className='d-flex flex-row justify-content-center mt-2'>
                                          <div className=' m-3'>
                                            <strong>
                                            Showing {titleRecordRange?.startRecord}ΓÇô{titleRecordRange?.endRecord} of {titleDescriptionPagination.count} records
                                            </strong>
                                          </div>
                                          <Button
                                            className='m-2 '
                                            size='sm'
                                            onClick={() => {
                                              setTitleDescriptionPagination((pre) => {
                                                return {
                                                  ...pre,
                                                  page: titleDescriptionPagination.page - 1,
                                                }
                                              })
                                              getTitleDescriptionListAsync(
                                                titleDescriptionPagination.page - 1
                                              )
                                            }}
                                            disabled={titleDescriptionPagination.previous == null}
                                          >
                                            -
                                          </Button>
                                          <Button
                                            className='m-2'
                                            size='sm'
                                            onClick={() => {
                                              setTitleDescriptionPagination((pre) => {
                                                return {
                                                  ...pre,
                                                  page: titleDescriptionPagination.page + 1,
                                                }
                                              })
                                              getTitleDescriptionListAsync(
                                                titleDescriptionPagination.page + 1
                                              )
                                            }}
                                            disabled={titleDescriptionPagination.next == null}
                                          >
                                            +
                                          </Button>
                                        </div>
                                      </div>
                                     
                                  </div>
                                )}
                              </>
                            )}
  
                            {/* <div className='text-center '>
                            <button
                              className='btn btn-primary btn-sm  mt-3'
                              onClick={() => {
                                setShowTable(false)
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowUp} />
                            </button>
                          </div> */}
                          </div>
                        ) : // <div className='text-center'>
                        //   <button
                        //     className='btn btn-primary btn-sm mt-3'
                        //     onClick={() => {
                        //       getTitleDescriptionListAsync(1)
                        //     }}
                        //   >
                        //     <FontAwesomeIcon icon={faArrowDown} />
                        //   </button>
                        // </div>
                        null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className='accordion p-0 pt-2 p-sm-2' id='priceModifierAccordion'>
                <div className='accordion-item shadow'>
                  <h2 className='accordion-header' id='priceModifierHeading'>
                    <button
                      className='accordion-button'
                      type='button'  
                      data-bs-toggle='collapse'
                      data-bs-target={'#priceModifierCollapse' + item?.id}
                      aria-expanded='false'
                      aria-controls={'priceModifierCollapse' + item?.id}
                      onClick={() => {
                        setPriceingTabel(!priceingTabel)
                        getPriceTemplateAsync(1)
                      }}
                    >
                      Price Modifier Rule
                    </button>
                  </h2>
                  <div
                    id={'priceModifierCollapse' + item?.id}
                    className='accordion-collapse collapse '
                    aria-labelledby='priceModifierHeading'
                    data-bs-parent='#priceModifierAccordion'
                  >
                    <div className='accordion-body'>
                    <div className='row d-flex'>
                        <div className="row pe-sm-0">
                            <div className='col-12 col-sm-6'>
                                <p className='fw-bold'>
                                    Add Price Modifier Rule for {item?.display_name}
                                </p>
                                      <div className="col-6">
                                        <input
                                          className='form-control mr-sm-2 input-sm '
                                          name="price"
                                          type='search '
                                          placeholder='Search By Name'
                                          aria-label='Search'
                                          onChange={handleChange}
                                          onKeyDown={(ev) => {
                                            if (ev.key == 'Enter') {
                                              getPriceTemplateAsync()

                                              // dispatch(
                                              //   setPaginationData({
                                              //     search: search.price,
                                              //     page: 1,
                                              //   })
                                              // )
                                          
                                            }
                                          }}
                                          value={search.price}
                                        />
                                        </div>
                            </div>
                            {isWrite && ( <div className='col-12 col-sm-6 d-flex justify-content-end pe-0 mb-3'>
                                <button
                                    className='btn btn-primary btn-sm align-self-end'
                                    onClick={async () => {
                                    setUpdatePriceItem(null)
                                    // Fetch master price types before opening modal
                                    try {
                                      const headers: Record<string, string> = {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                      }
                                      const token = localStorage.getItem(accessSessionTokenKeyName)
                                      const adminToken = localStorage.getItem(loggedInAdminAccessToken)
                                      if (token) {
                                        headers.Authorization = `Bearer ${token}`
                                      }
                                      if (adminToken) {
                                        headers['xadmin'] = adminToken
                                      }
                                      
                                      // Call price field API to get master price types
                                      // Endpoint: /platform-price-field?platform_id={id}
                                      // Returns array of price types with api_name, api_id, type
                                      const platformId = item?.id
                                      if (!platformId) {
                                        toast.error('Platform ID is required.')
                                        return
                                      }
                                      
                                      const response = await axios.get(
                                        `${process.env.REACT_APP_API_URL || ''}/platform-price-field`,
                                        { 
                                          params: { platform_id: platformId },
                                          headers 
                                        }
                                      )
                                      
                                      // Extract price types (items with api_name, api_id, type)
                                      // Price types have: api_name, api_id, type, platform, platform_field
                                      // Price templates have: name, platform_id, repricing, isDefault
                                      let priceTypes: PRICE_TEMPLATE_FIELD[] = []
                                      if (Array.isArray(response?.data)) {
                                        priceTypes = response.data.filter((item: any) => 
                                          item.api_name && item.api_id && item.type && !item.name
                                        ) as PRICE_TEMPLATE_FIELD[]
                                      } else if (Array.isArray(response?.data?.results)) {
                                        priceTypes = response.data.results.filter((item: any) => 
                                          item.api_name && item.api_id && item.type && !item.name
                                        ) as PRICE_TEMPLATE_FIELD[]
                                      }
                                      
                                      // Filter by platform to ensure correct platform
                                      if (priceTypes.length > 0) {
                                        priceTypes = priceTypes.filter((pt) => 
                                          pt.platform === platformId || pt.platform === Number(platformId)
                                        )
                                      }
                                      
                                      // Store price types and open modal
                                      setInitialPriceTypesForModal(priceTypes)
                                      setShowPriceTemplateModal(true)
                                    } catch (error) {
                                      console.error('Error fetching price types:', error)
                                      toast.error('Unable to load price types. Please try again.')
                                    }
                                    }}
                                >
                                    + Add New Rules
                                </button>
                            </div> )}
                        </div>
                        {priceingTabel ? (
                          <div className='p-0 p-sm-2' >
                            {platformPricingTemplateLoading ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <h1>
                                  <Spinner animation='border' variant='primary' />
                                </h1>
                              </div>
                            ) : (
                              <>
                                {priceTemplatePagination.count === 0 ? (
                                  // Content to render when recipePagination.count is equal to 0
                                  <p className='mt-3'>No Price Modifier Rule found </p>
                                ) : (
                                  // Content to render when recipePagination.count is not equal to 0
                                  <div>
                                   <div className='card-body w-100 py-3'>
                                        {/* begin::Table container */}
                                        <div className='table-responsive '>
                                          {/* begin::Table */}
                                          <table className='table table-striped table-hover table-sm gs-0 gy-4'>
                                            {/* begin::Table head */}
                                            <thead>
                                              <tr className='fw-bold text-muted  border-bottom border-bottom-2'>
                                                <th className='min-w-150px ps-4'>Rule Name</th>
                                                {platformCategories && <th className='min-w-150px ps-4 '>
                                                  <div className='d-flex gap-3'>Created At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div>
                                                  </th>}
                                                {platformCategories && <th className='min-w-150px ps-4 '>
                                                  <div className='d-flex gap-3'>Updated At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div>
                                                  </th>}
                                                <th className='min-w-100px text-center'>Actions</th>
                                              </tr>
                                            </thead>
                                            {/* end::Table head */}
                                            {/* begin::Table body */}
                                            <tbody>
                                              {priceTemplateList
                                                ? priceTemplateList.map((currentitem) => (
                                                    <>
                                                      <TemplateListItemcopy
                                                        key={currentitem.id}
                                                        name={currentitem.name}
                                                        created_at={currentitem?.created_at}
                                                        updated_at={currentitem?.updated_at}
                                                        // Pass update and delete handler functions here
                                                        onUpdate={() =>
                                                          handleUpdatePrice(currentitem)
                                                        }
                                                        onDelete={() =>
                                                     {     setSelectedTemplateDataForDelete(currentitem)
                                                      setShowAlertModalPrice(true)}
                                                          // handleDeletePrice(currentitem)
                                                        }
                                                      />
                                                      {/* <div className='border-bottom my-2 border-2'></div> */}
                                                    </>
                                                  ))
                                                : null}
                                            </tbody>
                                            {/* end::Table body */}
                                          </table>
                                          {/* end::Table */}
                                        </div>
                                        {/* end::Table container */}
                                     
                                    </div>
                                      <div className='d-flex flex-column'>
                                        <div className='border-bottom my-2 border-2'></div>
                                        <div className='d-flex flex-row justify-content-center mt-2'>
                                          <div className=' m-3'>
                                            <strong>
                                            Showing {priceRecordRange?.startRecord}ΓÇô{priceRecordRange?.endRecord} of {priceTemplatePagination.count} records
                                            </strong>
                                          </div>
                                          <Button
                                            className='m-2'
                                            onClick={() => {
                                              setPriceTemplatePagination((pre) => {
                                                return {
                                                  ...pre,
                                                  page: priceTemplatePagination.page - 1,
                                                }
                                              })
                                              getPriceTemplateAsync(priceTemplatePagination.page - 1)
                                            }}
                                            disabled={priceTemplatePagination.previous == null}
                                          >
                                            -
                                          </Button>
                                          <Button
                                            className='m-2'
                                            onClick={() => {
                                              setPriceTemplatePagination((pre) => {
                                                return {
                                                  ...pre,
                                                  page: priceTemplatePagination.page + 1,
                                                }
                                              })
                                              getPriceTemplateAsync(priceTemplatePagination.page + 1)
                                            }}
                                            disabled={priceTemplatePagination.next == null}
                                          >
                                            +
                                          </Button>
                                        </div>
                                      </div>
                                  </div>
                                )}
                              </>
                            )}
  
                            {/* <div className='text-center '>
                            <button
                              className='btn btn-primary btn-sm mt-3'
                              onClick={() => {
                                setPriceingTabel(false)
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowUp} />
                            </button>
                          </div> */}
                          </div>
                        ) : // <div
                        //   className='text-center '
                        //   onClick={() => {
                        //     getPriceTemplateAsync(1)
                        //   }}
                        // >
                        //   <button className='btn btn-primary btn-sm mt-3'>
                        //     <FontAwesomeIcon icon={faArrowDown} />
                        //   </button>
                        // </div>
                        null}
                    </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className='accordion p-0 pt-2 p-sm-2' id='categoryMappingAccordion'>
                <div className='accordion-item shadow'>   
                  <h2 className='accordion-header' id='categoryMappingHeading'>
                    <button
                      className='accordion-button'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target={'#categoryMappingCollapse' + item?.id}
                      aria-expanded='false'
                      aria-controls={'categoryMappingCollapse' + item?.id}
                      onClick={() => {
                        setShowCategoryData1(!showCategoryData1)
                        getCategoriesAsync()
                      }}
                    >
                      <span className='required-sm'>Category Mapping Rule </span>
                    </button>
                  </h2>
                  <div
                    id={'categoryMappingCollapse' + item?.id}
                    className='accordion-collapse collapse '
                    aria-labelledby='categoryMappingHeading'
                    data-bs-parent='#categoryMappingAccordion'
                  >
                    <div className='accordion-body'>
                    <div className='row d-flex'>
                        <div className="row pe-sm-0">
                            <div className='col-12 col-sm-6'>
                            <p className='fw-bold '>
                            {' '}
                            Add Category Mapping Rule for {item?.display_name}
                          </p>
                                <div className="col-6">
                                        <input
                                          className='form-control mr-sm-2 input-sm '
                                          name="category"
                                          type='search'
                                          placeholder='Search By Name'
                                          aria-label='Search'
                                          onChange={handleChange}
                                          onKeyDown={(ev) => {
                                            if (ev.key == 'Enter') {
                                          getCategoriesAsync()
                                          
                                            }
                                          }}
                                          value={search.category}
                                        />
                                        </div>
                            </div>
                            {isWrite && (<div className='col-12 col-sm-6 d-flex justify-content-end pe-0 mb-3'>
                            <button
                            className='btn btn-primary btn-sm align-self-end '
                            onClick={() => {
                              setShowCategoryTemplateModal(true)
                            }}
                          >
                            + Add New Rules
                          </button>
                            </div>)}
                        </div>
  
                        {showCategoryData1 ? (
                          <div className='p-0 p-sm-2' >
                            {loadCategorieData ? (
                              <div className='d-flex align-items-center justify-content-center'>
                                <h1>
                                  <Spinner animation='border' variant='primary' />
                                </h1>
                              </div>
                            ) : (
                              <>
                                {paginationCategoryData.count === 0 ? (
                                  // Content to render when recipePagination.count is equal to 0
                                  <p className='mt-3'>No Category Mapping Rule found </p>
                                ) : (
                                  // Content to render when recipePagination.count is not equal to 0
                                  <div>
                                      <div className='card-body w-100 py-3'>
                                        {/* begin::Table container */}
                                        <div className='table-responsive '>
                                          {/* begin::Table */}
                                          <table className='table table-striped table-hover table-sm gs-0 gy-4'>
                                            {/* begin::Table head */}
                                            <thead>
                                              <tr className='fw-bold text-muted  border-bottom border-bottom-2'>
                                                <th className='min-w-150px ps-4 '>Rule Name</th>
                                                {platformCategories && <th className='min-w-150px ps-4 '>
                                                  <div className='d-flex gap-3'>Created At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div>
                                                  </th>}
                                                {platformCategories && <th className='min-w-150px ps-4 '>
                                                  <div className='d-flex gap-3'>Updated At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div>
                                                  </th>}
                                                <th className='min-w-100px ps-4 '>Actions</th>
                                              </tr>
                                            </thead>
                                            {/* end::Table head */}
                                            {/* begin::Table body */}
                                            <tbody>
                                              {platformCategories?.length
                                                ? platformCategories.map((templateData) => (
                                                    <>
                                                      <TemplateListItemcopy
                                                        key={templateData.id}
                                                        name={templateData.name}
                                                        created_at={templateData?.created_at}
                                                        updated_at={templateData?.updated_at}
                                                        // Pass update and delete handler functions here
                                                        onUpdate={() =>
                                                          handleUpdateCategory(templateData)
                                                        }
                                                        onDelete={() => {

                                                               setSelectedTemplateDataForDelete(templateData)
                                                            setShowAlertModalCategory(true)
                                                          // setloadCategorieData(true)
                                                         
                                                        }}
                                                      />
                                                      {/* <div className='border-bottom my-2 border-2'></div> */}
                                                    </>
                                                  ))
                                                : null}
                                            </tbody>
                                            {/* end::Table body */}
                                          </table>
                                          {/* end::Table */}
                                        </div>
                                        {/* end::Table container */}
                                      </div>
                                    
                                      <div className='d-flex flex-column'>
                                        <div className='border-bottom my-2 border-2'></div>
                                        <div className='d-flex flex-row justify-content-center mt-2'>
                                          <div className=' m-3'>
                                            <strong>
                                            Showing {categoryRecordRange?.startRecord}ΓÇô{categoryRecordRange?.endRecord} of {paginationCategoryData.count} records
                                            </strong>
                                          </div>
                                          <Button
                                            className='m-2'
                                            onClick={() => {
                                              setPaginationCategoryData((pre) => {
                                                return {...pre, page: paginationCategoryData.page - 1}
                                              })
                                              getCategoriesAsync(paginationCategoryData.page - 1)
                                            }}
                                            disabled={paginationCategoryData.previous == null}
                                          >
                                            -
                                          </Button>
                                          <Button
                                            className='m-2'
                                            // onClick={() => {
                                            //   handlePaginationCategory(paginationCategoryData.page + 1)
                                            //   onSendPaginationCategory(paginationCategoryData)
                                            // }}
                                            // disabled={next == null}
                                            onClick={() => {
                                              setPaginationCategoryData((pre) => {
                                                return {...pre, page: paginationCategoryData.page + 1}
                                              })
                                              getCategoriesAsync(paginationCategoryData.page + 1)
                                            }}
                                            disabled={paginationCategoryData.next == null}
                                          >
                                            +
                                          </Button>
                                        </div>
                                      </div>
                                  </div>
                                )}
                              </>
                            )}
                            {/* 
                          <div className='text-center '>
                            <button
                              className='btn btn-primary btn-sm mt-3'
                              onClick={() => {
                                setShowCategoryData1(false)
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowUp} />
                            </button>
                          </div> */}
                          </div>
                        ) : // <div
                        //   className='text-center'
                        //   // onClick={() => {
                        //   //   onClickShowCategoryTable(item?.id)
                        //   // }}
                        // >
                        //   <button
                        //     className='btn btn-primary btn-sm mt-3'
                        //     onClick={() => {
                        //       getCategoriesAsync()
                        //     }}
                        //   >
                        //     <FontAwesomeIcon icon={faArrowDown} />
                        //   </button>
                        // </div>
                        null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              {/* <div className=' my-2 fs-16 text-center'> */}
                {/* <Button
                  // disabled={selectedCategoryIdForMapping == null}
                  onClick={() => callFieldMapping(item)}
                >
                 Load more mapping rules
                </Button> */}
                {/* {showMoreMapping ? null : (
                  <button
                    type='button'
                    className='btn btn-sm fw-bold btn-primary'
                    onClick={() => callFieldMapping(item)}
                  >
                    {' '}
                    Click to see more Rules{' '}
                    {mappingLoading && <Spinner animation='border' size='sm' />}
                  </button>
                )}
              </div> */}

              
              {showMoreMapping && moreFieldMappingData.length > 0 && (
                <div>
                  {moreFieldMappingData.map((item) => (
                    <MoreMappingItem
                    item={item}
                    selectedPlatform={selectedPlatformId}
                    handleChange ={handleChange}
                    searchdata = {search}
                    currentActivePlatform={currentActivePlatform}
                    />
                  ))}
                </div>
              )}
            </div>
            {showAddTitleDescriptionModal ? 
            <AddNewTitleDescriptionModal
              isVisible={showAddTitleDescriptionModal}
              closeModal={handleCloseModal}
              selectedSecondaryPlatform={item}
              getLatestTitleDescriptionList={() => {
                setTitleDescriptionPagination({
                  page: 1,
                  count: 0,
                  limit: 10,
                  next: null,
                  previous: null,
                })
                getTitleDescriptionListAsync(1)
              }}
              updateItem={updatingTitleDescriptionData}
            /> : null }
            <AddNewPriceTemplateModal
              isVisible={showPriceTemplateModal}
              closeModal={() => {
                setShowPriceTemplateModal(false)
                setInitialPriceTypesForModal([])
              }}
              selectedSecondaryPlatform={item}
              getLatestPriceTemplateList={() => {
                setPriceTemplatePagination({page: 1, count: 0, limit: 10, next: null, previous: null})
                getPriceTemplateAsync(1)
              }}
              updateItem={updatePriceItem}
              initialPriceTypes={initialPriceTypesForModal}
              hasTemplateRecords={priceTemplatePagination.count > 0}
            />
  
            <AddNewCategoryTemplateModal
              key={'addCatModal' + item.id}
              isVisible={showCategoryTemplateModal}
              closeModal={() => {
                setShowCategoryTemplateModal(false)
                setCategoryTemplateForUpdate(null)
              }}
              selectedSecondaryPlatform={item}
              categoryData={categoryTemplateForUpdate}
              getLatestCategoryTemplateList={() => getCategoriesAsync(1)}
            />
            {showMoreMappingTemplateModal && selectedMappingItem && (
              <AddNewMoreMappingTemplateModal
                isVisible={showMoreMappingTemplateModal}
                item={selectedMappingItem}
                selectedSecondaryPlatform={item}
                closeModal={() => setShowMoreMappingTemplateModal(false)}
                moreMappingData={updatingMoreMappingData}
                getLatestMoreMappingDataList={() => getMoreMappingDataAsync(1)}
              />
            )}
          </div>
        )}

        {activeTab.tab2 && (
          <div className='p-0 p-sm-2'>
            <div className='row p-2'>
              {optionAttributeList ? (
                <div className='p-0 p-sm-2'>
                  {optionAttributeListLoading ? (
                    <div className='d-flex align-items-center justify-content-center'>
                      <h1>
                        <Spinner animation='border' variant='primary' />
                      </h1>
                    </div>
                  ) : (
                    <>
                      {optionAttributeList.length === 0 ? (
                        <p className='mt-3'>No Mapping found, Click Add New Mapping to create one</p>
                      ) : (
                        <div className='justify-content-center d-flex mt-3'>
                          <div className='justify-content-center card col-12'>
                            <div className='card-body w-100 py-3'>
                              <div className='table-responsive'>
                                <table className='table table-striped table-hover table-sm gs-0 gy-4'>
                                  <thead>
                                    <tr className='fw-bold text-muted border-bottom border-bottom-2'>
                                      <th className='min-w-175px ps-4'>Attribute/Option Name</th>
                                      <th className='min-w-175px ps-4'>Attribute Name</th>
                                      <th className='min-w-140px ps-4'>Category Name</th>
                                      {optionAttributeList && (
                                        <th className='min-w-175px ps-4'>
                                          <div className='d-flex gap-3 text-nowrap'>Created At
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'}}>
                                              <OverlayTrigger placement='top' overlay={<Tooltip>{formatTimeZone()}</Tooltip>}>
                                                <span style={{ cursor: 'pointer' }}>
                                                  <FontAwesomeIcon icon={faInfoCircle} />
                                                </span>
                                              </OverlayTrigger>
                                            </div>
                                          </div>
                                        </th>
                                      )}
                                      {optionAttributeList && (
                                        <th className='min-w-175px ps-4'>
                                          <div className='d-flex gap-3 text-nowrap'>Updated At
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'}}>
                                              <OverlayTrigger placement='top' overlay={<Tooltip>{formatTimeZone()}</Tooltip>}>
                                                <span style={{ cursor: 'pointer' }}>
                                                  <FontAwesomeIcon icon={faInfoCircle} />
                                                </span>
                                              </OverlayTrigger>
                                            </div>
                                          </div>
                                        </th>
                                      )}
                                      <th className='min-w-100px ps-4'>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {optionAttributeList?.length
                                      ? optionAttributeList.map((recipe) => (
                                            <TemplateListItemcopy
                                              key={recipe.id}
                                              name={recipe.name}
                                              mapped_attribute_name={recipe?.mapped_attribute_name}
                                              mapped_cat_name={recipe?.mapped_cat_name}
                                              created_at={recipe?.created_at}
                                              updated_at={recipe?.updated_at}
                                              onUpdate={() => {
                                                setShowOptionsAndAttributeModal(true)
                                                setSelectedMappedDataAttributeForEdit(recipe)
                                              }}
                                              onDelete={() => {
                                                setShowOptionDataAttributeMappingDelete(true)
                                                setSelectedMappedDataAttributeForDelete(recipe)
                                              }}
                                            />
                                        ))
                                      : null}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className='d-flex flex-column'>
                              <div className='border-bottom my-2 border-2'></div>
                              <div className='d-flex flex-row justify-content-center mt-2'>
                                <div className='m-3'>
                                  <strong>
                                    Showing {optionAttributePagination.count ? optionAttributePagination.skip + 1 : 0}-
                                    {Math.min(optionAttributePagination.skip + optionAttributeList.length, optionAttributePagination.count)} of {optionAttributePagination.count} Records
                                  </strong>
                                </div>
                                <Button
                                  className='m-2'
                                  onClick={() => {
                                    const nextPage = optionAttributePagination.page - 1
                                    setOptionAttributePagination((pre) => ({ ...pre, page: nextPage }))
                                    getOptionAttributeMaping(nextPage)
                                  }}
                                  disabled={optionAttributePagination.page <= 1}
                                >
                                  -
                                </Button>
                                <Button
                                  className='m-2'
                                  onClick={() => {
                                    const nextPage = optionAttributePagination.page + 1
                                    setOptionAttributePagination((pre) => ({ ...pre, page: nextPage }))
                                    getOptionAttributeMaping(nextPage)
                                  }}
                                  disabled={optionAttributePagination.page * optionAttributePagination.limit >= optionAttributePagination.count}
                                >
                                  +
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}
            </div>
            <AttributeAndOptionValueMappingModal
              dataForEdit={selectedMappedAttributeForEdit}
              item={item}
              showOptionsAndAttributeModal={showOptionsAndAttributeModal}
              setShowOptionsAndAttributeModal={setShowOptionsAndAttributeModal}
              getOptionAttributeMaping={() => getOptionAttributeMaping(1, true)}
            />
          </div>
        )}
        {activeTab.tab3 && (
          <div className='p-0 p-sm-2'>
            <div className='my-2'>
              <p className='h5 mt-2'>Manage your Product Listing Plans</p>
            </div>
            <div className='accordion p-0 pt-2 p-sm-2' id='productListingAccordion'>
              <div className='accordion-item shadow'>
                <h2 className='accordion-header' id='productListingHeading'>
                  <button
                    className='accordion-button'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target={'#productListingCollapse' + item.id}
                    aria-expanded='false'
                    aria-controls={'productListingCollapse' + item.id}
                    onClick={() => {
                      setShowRecipeData(!showRecipeData)
                      getRecipesAsync(1)
                    }}
                  >
                    Add Plan for Product listing
                  </button>
                </h2>
                <div
                  id={'productListingCollapse' + item.id}
                  className='accordion-collapse collapse show'
                  aria-labelledby='productListingHeading'
                  data-bs-parent='#productListingAccordion'
                >
                  <div className='accordion-body'>
                    {/* Original content goes here */}
                    <div className='row  p-2 my-2 mt-3'>
                    <div className="row pe-sm-0">
                      <div className='col-12 col-sm-6'>
                        <p className='fw-bold'>
                          Add Plan for Product listing {item.display_name}{' '}
                        </p>
                            <div className="col-6">
                                        <input
                                          className='form-control mr-sm-2 input-sm '
                                          name="plan"
                                          type='search'
                                          placeholder='Search By Name'
                                          aria-label='Search'
                                          onChange={handleChange}
                                          onKeyDown={(ev) => {
                                            if (ev.key == 'Enter') {

                                              getRecipesAsync(1)
                                            }
                                          }}
                                          value={search.plan}
                                        />
                          
                                        </div>
                      </div>
                      <div className='col-12 col-sm-6 d-flex justify-content-end pe-0 mb-3'>
                        {isWrite && (<button
                          className='btn btn-primary btn-sm align-self-end'
                          onClick={() => {
                            onClickAddNewRecipeModal()
                          }}
                        >
                          + Add New Plan
                        </button>
                        )}
                      </div>
                    </div>
                      {showRecipeData ? (
                        <div className='p-0 p-sm-2' >
                          {loadRecipeData ? (
                            <div className='d-flex align-items-center justify-content-center'>
                              <h1>
                                <Spinner animation='border' variant='primary' />
                              </h1>
                            </div>
                          ) : (
                            <>
                              {/* Content inside the accordion's collapsed section */}
                              {recipePagination.count === 0 ? (
                                // Content to render when recipePagination.count is equal to 0
                                <p className='mt-3'>No Listing Plan found </p>
                              ) : (
                                // Content to render when recipePagination.count is not equal to 0
                                <div className='justify-content-center d-flex mt-3'>
                                  <div className='justify-content-center card col-12'>
                                    <div className='card-body w-100 py-3'>
                                      {/* begin::Table container */}
                                      <div className='table-responsive '>
                                        {/* begin::Table */}
                                        <table className='table table-striped table-hover table-sm   gs-0 gy-4'>
                                          {/* begin::Table head */}
                                          <thead>
                                            <tr className='fw-bold text-muted  border-bottom border-bottom-2'>
                                              <th className='min-w-150px ps-4'>Rule Name</th>
                                              {platformRecipes && <th className='min-w-150px ps-4'>
                                                <div className='d-flex gap-3'>Created At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div>
                                                </th>}
                                              {platformRecipes && <th className='min-w-150px ps-4'>
                                                <div className='d-flex gap-3'>Updated At 
                                                    <div style={{display: "flex", alignItems:"center", justifyContent: "center", gap: "6px"}}>
                                                      <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
                                                        >
                                                        <span style={{ cursor: 'pointer' }}>
                                                          <FontAwesomeIcon icon={faInfoCircle} />
                                                        </span>
                                                      </OverlayTrigger>
                                                    </div>
                                                  </div>
                                                </th>}
                                                <th className='min-w-100px ps-4'>Actions</th>
                                            </tr>
                                          </thead>
                                          {/* end::Table head */}
                                          {/* begin::Table body */}
                                          <tbody>
                                            {platformRecipes?.length
                                              ? platformRecipes.map((recipe) => (
                                                    <TemplateListItemcopy
                                                      key={recipe.id}
                                                      name={recipe.name}
                                                      created_at={recipe?.created_at}
                                                      updated_at={recipe?.updated_at}
                                                      // Pass update and delete handler functions here
                                                      onUpdate={() => {
                                                        setShowAddRecipeModal(true)
                                                        setUpdatingRecipeData(recipe)
                                                      }}
                                                      onDelete={() => {
                                                        // setLoadRecipeData(true)
                                                        setSelectedTemplateDataForDelete(recipe)
                                                        setShowAlertModalListing(true)
                                                      
                                                      }}
                                                    />
                                                ))
                                              : null}
                                          </tbody>
                                          {/* end::Table body */}
                                        </table>
                                        {/* end::Table */}
                                      </div>
                                      {/* end::Table container */}
                                    </div>
  
                                    <div className='d-flex flex-column'>
                                      <div className='border-bottom my-2 border-2 '></div>
                                      <div className='d-flex flex-row justify-content-center mt-2'>
                                        <div className=' m-3'>
                                          <strong>Total {recipePagination.count} Records </strong>
                                        </div>
                                        <Button
                                          className='m-2'
                                          onClick={() => {
                                            setRecipePagination((pre) => {
                                              return {...pre, page: recipePagination.page - 1}
                                            })
                                            getRecipesAsync(recipePagination.page - 1)
                                          }}
                                          disabled={recipePagination.previous == null}
                                        >
                                          -
                                        </Button>
                                        <Button
                                          className='m-2'
                                          onClick={() => {
                                            setRecipePagination((pre) => {
                                              return {...pre, page: recipePagination.page + 1}
                                            })
                                            getRecipesAsync(recipePagination.page + 1)
                                          }}
                                          disabled={recipePagination.next == null}
                                        >
                                          +
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          {/* Toggle button */}
                          {/* <div className='text-center'>
                      <button
                        className='btn btn-primary btn-sm mt-3'
                        onClick={() => {
                          setShowRecipeData(false);
                        }}
                      >
                        <FontAwesomeIcon icon={faArrowUp} />
                      </button>
                    </div> */}
                        </div>
                      ) : (
                        // Button to expand the accordion
                        <div className='text-center'>
                          <button
                            className='btn btn-primary btn-sm mt-3'
                            onClick={() => {
                              getRecipesAsync()
                            }}
                          >
                            <FontAwesomeIcon icon={faArrowDown} />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <AddNewRecipeModal
              key={'recipeModal' + item?.id}
              isVisible={showAddRecipeModal}
              closeModal={() => 
              {  
                setShowAddRecipeModal(false)
                setUpdatingRecipeData(null)
              }
              }
              selectedSecondaryPlatform={item}
              getLatestRecipesList={() => {
                setRecipePagination({page: 1, count: 0, limit: 5, next: null, previous: null})
                getRecipesAsync(1)
              }}
              recipeData={updatingRecipeData}
            />
          </div>
        )}
        {activeTab.tab4 && (
          <>
            <CreateQuickListTab platformId={item?.id} selectedSecondaryPlatform={item} currentActivePlatform={currentActivePlatform} />
          </>
        )}

        <CommonAlertModal
           key={'title description'}
           title={` Are You Ready to Continue?`}
           subtitle='Click "Yes" to proceed.'
          //  successBtnTitle={ loggingIn ? 'Logging in...' : 'Confirm'}
          //  successDisabled={loggingIn}
           isVisible={showAlertModalTitle}
           onSuccess={()=>{
            try {
              if (selectedTemplateDataForDelete && selectedTemplateDataForDelete.id !== undefined) {
                dispatch(deleteTitleDescriptionTemplateAsync({platform_id: selectedTemplateDataForDelete?.id}))
                  .then((response) => {
                    if (!isApiPayloadSuccess(response)) {
                      errorToast(getApiErrorMessage(response, 'Unable to delete title/description template.'))
                      return
                    }
                    getTitleDescriptionListAsync(1)
                    successToast('Deleted Successfully!')
                  })
                  .catch((error) => {
                    errorToast(getApiErrorMessage(error, 'Unable to delete title/description template.'))
                  })
              } else {
                console.error('template data  id is undefined.')
              }
            } catch (error) {
              console.error('Error deleting platform:', error)
              errorToast(getApiErrorMessage(error, 'Unable to delete title/description template.'))
            } finally {
              setShowAlertModalTitle(false)
            }
           }}
           onCancel={()=>{
         
            setSelectedTemplateDataForDelete(null)
            setShowAlertModalTitle(false)
           }}
           isTermsVisible={false}
          />
             <CommonAlertModal
           key={'price modifier'}
         title={` Are You Ready to Continue?`}
           subtitle='Click "Yes" to proceed.'
          //  successBtnTitle={ loggingIn ? 'Logging in...' : 'Confirm'}
          //  successDisabled={loggingIn}
           isVisible={showAlertModalPrice}
           onSuccess={()=>{
            dispatch(deletPlatformPriceAsync({template_id: selectedTemplateDataForDelete?.id}))
            .then((response) => {
              // Check if the action was rejected (error case)
              if (response.payload?.data?.error || response.payload?.error) {
                errorToast(response.payload?.data?.error || response.payload?.error)
              } else if (response.payload?.success) {
                successToast(response.payload.success)
                getPriceTemplateAsync(1)
              }
            })
            .catch((error) => {
              console.log('error', error)
              errorToast(error?.message || 'Failed to delete price template')
            })
            setShowAlertModalPrice(false)

           }}
           onCancel={()=>{
         
         
            setShowAlertModalPrice(false)
           }}
           isTermsVisible={false}
          />
             <CommonAlertModal
           key={'category'}
            title={` Are You Ready to Continue?`}
           subtitle='Click "Yes" to proceed.'
          //  successBtnTitle={ loggingIn ? 'Logging in...' : 'Confirm'}
          //  successDisabled={loggingIn}
           isVisible={showAlertModalCategory}
           onSuccess={()=>{
            dispatch(
              deleteCategoryTemplateDataAsync({
                category_template: selectedTemplateDataForDelete.id,
              })
            )
              .then((response) => {
                handleThunkResponse(response, {
                  successToast,
                  errorToast,
                  successMessage: 'Deleted Successfully',
                  errorFallback: 'Unable to delete category mapping rule.',
                  onSuccess: () => {
                    setloadCategorieData(false)
                    getCategoriesAsync(1)
                  },
                  onError: () => setloadCategorieData(false),
                  showSuccessToast: true,
                })
              })
              .finally(() => {
                setShowAlertModalCategory(false)
              })
           }}
           onCancel={()=>{
         
            setSelectedTemplateDataForDelete(null)
            setShowAlertModalCategory(false)
           }}
           isTermsVisible={false}
          />
                 <CommonAlertModal
           key={'recipie listing'}
            title={` Are You Ready to Continue?`}
           subtitle='Click "Yes" to proceed.'
          //  successBtnTitle={ loggingIn ? 'Logging in...' : 'Confirm'}
          //  successDisabled={loggingIn}
           isVisible={showAlertModalListing}
           onSuccess={()=>{
            dispatch(
              deleteRecipeAsync({
                templateMappingId: selectedTemplateDataForDelete.id,
              })
            )
              .then((response) => {
                if (!isApiPayloadSuccess(response)) {
                  errorToast(getApiErrorMessage(response, 'Unable to delete listing plan.'))
                  return
                }
                setLoadRecipeData(false)
                getRecipesAsync(1)
                successToast('Deleted Successfully')
              })
              .catch((error) => {
                errorToast(getApiErrorMessage(error, 'Unable to delete listing plan.'))
                setLoadRecipeData(false)
              })
              .finally(() => {
                setShowAlertModalListing(false)
              })
           }}
           onCancel={()=>{
         
            setSelectedTemplateDataForDelete(null)
            setShowAlertModalListing(false)
           }}
           isTermsVisible={false}
          />
          <CommonAlertModal
           key={'mappingAttribute'}
            title={`Do you want to delete ${selectedMappedAttributeForDelete?.name} Attribute Mapping`}
           subtitle='Click "Yes" to proceed.'
           isVisible={showOptionDataAttributeMappingDelete}
           onSuccess={()=>{
            setOptionAttributeListLoading(true)
            dispatch(
              deleteOptionsAttributeMapping({
                platform_attribute_option_template_id: selectedMappedAttributeForDelete?.id,
              })
            )
              .then((response) => {
                if (!isApiPayloadSuccess(response)) {
                  errorToast(getApiErrorMessage(response, 'Unable to delete attribute mapping.'))
                  return
                }
                getOptionAttributeMaping(1, true)
                successToast('Deleted Successfully')
              })
              .catch((error) => {
                errorToast(getApiErrorMessage(error, 'Unable to delete attribute mapping.'))
              })
              .finally(()=>{
                setShowOptionDataAttributeMappingDelete(false)
                setOptionAttributeListLoading(false)
              })
           }}
           onCancel={()=>{
            setSelectedMappedDataAttributeForDelete(null)
            setShowOptionDataAttributeMappingDelete(false)
           }}
           isTermsVisible={false}
          />
      </div>
    )
  }


  export default TemaplateComponent
